import { object } from "yup";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import {
  ClinicResource,
  clinicResourceSchema,
} from "@client/resources/ClinicResource";

export const fetchClinic = async (): Promise<ApiResponse<ClinicResource>> => {
  const response = await fetchData("/dietitian/clinic", APIMethods.GET);
  const responseSchema = object({
    data: clinicResourceSchema.required(),
  });
  return await responseSchema.validate(response);
};

export type ClinicDto = ClinicResource;
